<template>
  <div class="box" v-show="refinements.length > 0">
    <span
      class="tag is-info"
      v-for="refinement in refinements"
      :key="refinement.name"
    >
      {{ refinement.name }}
      <span class="delete" @click="cancel(refinement)"></span>
    </span>
  </div>
</template>

<script>
import { Component } from 'vue-instantsearch';

export default {
  mixins: [Component],
  computed: {
    refinementsObject() { return this.searchStore.activeRefinements; },
    refinements() {
      return Object.keys(this.refinementsObject).map(f => this.refinementsObject[f]);
    },
  },
  methods: {
    cancel(refinement) {
      return this.searchStore.toggleFacetRefinement(
        refinement.attributeName,
        refinement.name,
      );
    },
  },
};
</script>
